import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// @ts-ignore
import { registerLicense } from '@syncfusion/ej2-base';

import bootstrap5 from '@formio/bootstrap/bootstrap5';
import { Formio } from 'formiojs';

// Registering Syncfusion license key - the specific key depends on the major.minor version
// registerLicense("ORg4AjUWIQA/Gnt2V1hhQlJAfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5UdEFhWn9bcnJURWJc"); // 22.1.*
// registerLicense("Ngo9BigBOggjHTQxAR8/V1NHaF5cWWBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWH5ecnRQRmddUUN/X0I="); // 23.1.*
// registerLicense("Ngo9BigBOggjHTQxAR8/V1NHaF1cWmhIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEZiW35ccHJQQ2VZWUF2XQ=="); // 23.2.*
registerLicense("Ngo9BigBOggjHTQxAR8/V1NAaF5cWWJCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdgWH1cc3RVRGRYV0VwXkU="); // 24.1.*

if (environment.production) {
  enableProdMode();
}

// Register the bootstrap5 templates with Formio
Formio.use(bootstrap5);
// Patch the iconClass function to convert fa5 icons to fa4
(Formio as any).Templates.current.iconClass = function (iconset, name, spinning) {
  if (iconset === 'fa') {
    switch (name) {
      case 'save':
        name = 'download';
        break;
      case 'zoom-in':
        name = 'search-plus';
        break;
      case 'zoom-out':
        name = 'search-minus';
        break;
      case 'question-sign':
        name = 'question-circle';
        break;
      case 'remove-circle':
        name = 'times-circle-o';
        break;
      case 'new-window':
        name = 'window-restore';
        break;
      case 'move':
        name = 'arrows';
        break;
    }
  }
  return spinning ? iconset + " " + iconset + "-" + name + " " + iconset + "-spin" : iconset + " " + iconset + "-" + name;
};

platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
  ngZoneRunCoalescing: true
}).then((moduleRef) => {
    // Remove the Syncfusion license div. This is sometimes necessary even though we always have a valid license key.
    const licenseDiv = document.querySelector('div[style*="z-index: 999999999"]');
    licenseDiv?.remove();
  })
  .catch(err => console.error(err));
